<template>
  <fragment  v-if="$store.getters.isInRole('stats-list')">
     <a ref="attachmentA"></a>
    <!-- End Infobar Setting Sidebar -->
    <div class="row">
      <div class="col-12">
        <div class="card m-b-30">
          <div class="card-header row">
            <div class="col">
              <h5 class="card-title mb-0">Filtri</h5>
            </div>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-3">
                <b-form-datepicker
                  :show-decade-nav="true"
                  placeholder="Nessuna data selezionata"
                  v-model="from"
                  :id="'from-datepicker'"
                  :reset-button="true"
                  label-reset-button="Nessuna data"
                  reset-button-variant="btn-xs btn-danger-rgba"
                ></b-form-datepicker>
              </div>
              <div class="col-3">
                <b-form-datepicker
                  :show-decade-nav="true"
                  placeholder="Nessuna data selezionata"
                  v-model="to"
                  :id="'to-datepicker'"
                  :reset-button="true"
                  label-reset-button="Nessuna data"
                  reset-button-variant="btn-xs btn-danger-rgba"
                ></b-form-datepicker>
              </div>
              <div class="col-12 mt-2">
   <v-select :options="cities"  multiple  v-model="selectedcities" placeholder="Comuni"   />
              </div>
              <div class="col-12 mt-2">
   <v-select :options="newspapers" multiple  v-model="selectednewspapers" placeholder="Testate"   />
              </div>
            </div>

            <div class="row mt-2">
              <div class="col text-right">
                <div class="btn-group">

<button
                  class="btn btn-info-rgba mr-2"
                  v-if="$store.getters.isInRole('company-export')"
                  v-on:click="excel"
                >
                  <i class="fa fa-file-excel-o mr-2"></i>Esporta ricerca
                </button>

                  <button
                  :disabled="from=='' || to==''"
                    class="btn btn-primary-rgba mr-2"
                    v-on:click="loaddata"
                  >
                    <i class="feather icon-filter mr-2"></i>Filtra
                  </button>

                   <button class="btn btn-danger-rgba" v-on:click="resetdata">
                  <i class="feather icon-delete mr-2"></i>Elimina filtro
                </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card m-b-30">
          <div class="card-body">
             <div class="row border p-0 alert alert-info" v-if="kioskstats.length>0" >
<div class="col-6"></div>
 <div v-for="(y,index) in years" class="col-3">
                        <div class="row">
                          <div class="col-12 text-center"><strong>{{y}}</strong></div>
                      <div class="text-right col">
                       Spedite
                      </div>
                      <div class="text-right col">
                       Rese
                      </div>
                      <div class="text-right col">
                       Vendute
                        </div>
                      </div>
             </div>
             </div>
            <div class="row border p-0 alert alert-light" v-for="np in kioskstats" >
<div class="col-6">
 <a class="text-info text-title cursor" @click="np.visible=!np.visible" v-if="np.t!='total'">
   <i class="feather icon-plus-circle" v-if="!np.visible"></i><i class="feather icon-minus-circle" v-if="np.visible"></i> 
   
    {{ np.np }}
   </a>
  
    
                    </div>
                      <div v-for="y in np.yrs" class="col-3">
                        <div class="row">
                      <div class="text-right col">
                        {{ y.stats.p | toNumber }}
                      </div>
                      <div class="text-right col">
                        {{ y.stats.r | toNumber }}
                      </div>
                      <div class="text-right col">
                        {{ y.stats.s | toNumber }}
                        <p>
                         <small class="text-danger" v-if="y.stats.ds<0"><i class="feather icon-arrow-down"></i> {{ y.stats.ds | toNumber }}</small>
                        <small class="text-success" v-if="y.stats.ds>0"><i class="feather icon-arrow-up"></i> {{ y.stats.ds | toNumber }}</small>
                     </p> </div>
                      </div>
                    </div>
<div class="col-12" v-for="d in np.dates" v-if="np.visible">
  <div class="row   alert-secondary">
<div class="col-6 pl-4">
 <a class="text-warning text-title cursor" @click="d.visible=!d.visible"><i class="feather icon-plus-circle" v-if="!d.visible"></i><i class="feather icon-minus-circle" v-if="d.visible"></i>  {{ d.d |formatStatsDate }}</a>
  <button class="ml-3 btn btn-link  p-1 text-warning" v-if="d.notes.length>0"  @click="viewNotes(d.notes)">
   <i class="feather icon-info"></i> Note
     </button>
                    </div>
                      <div v-for="y in d.yrs" class="col-3">
                        <div class="row">
                      <div class="text-right col">
                        {{ y.stats.p | toNumber }}
                      </div>
                      <div class="text-right col">
                        {{ y.stats.r | toNumber }}
                      </div>
                      <div class="text-right col">
                        {{ y.stats.s | toNumber }}
                       <p>
                         <small class="text-danger" v-if="y.stats.ds<0"><i class="feather icon-arrow-down"></i> {{ y.stats.ds | toNumber }}</small>
                        <small class="text-success" v-if="y.stats.ds>0"><i class="feather icon-arrow-up"></i> {{ y.stats.ds | toNumber }}</small>
                     </p>                      </div>
                      </div>
                    </div>
</div>
<div class="col-12 p-0" v-for="c in d.cities" v-if="np.visible && d.visible">
  <div class="row bg-white">
<div class="col-6  pl-5">
 {{ c.city }} <button class="ml-3 btn btn-link  p-1 text-warning" v-if="c.notes.length>0"  @click="viewNotes(c.notes)">
   <i class="feather icon-info"></i> Note
     </button>
                   </div>
                      <div v-for="yc in c.yrs" class="col-3">
                        <div class="row">
                      <div class="text-right col">
                        {{ yc.stats.p | toNumber }}
                      </div>
                      <div class="text-right col">
                        {{ yc.stats.r | toNumber }}
                      </div>
                      <div class="text-right col">
                        {{ yc.stats.s | toNumber }}
<p>
                         <small class="text-danger" v-if="yc.stats.ds<0"><i class="feather icon-arrow-down"></i> {{ yc.stats.ds | toNumber }}</small>
                        <small class="text-success" v-if="yc.stats.ds>0"><i class="feather icon-arrow-up"></i> {{ yc.stats.ds | toNumber }}</small>
                     </p> </div>
                      </div>
                    </div>
</div>
</div>
</div>

            </div>
            
          </div>
        </div>
      </div>
    </div>
      <div
      class="modal fade"
      id="noteModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog slideInUp animated" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalCenterTitle">
              Elenco note
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12" v-for="(item,index) in notes">
                {{item.content}}
              </div>
            </div>
          </div>
       
        </div>
      </div>
    </div>
    <!-- /.col -->
  </fragment>
</template>

<script>
import axios from "axios";
export default {
  computed: {},
  components: {},
  data() {
    return {
      notes:[],
    years:[],
      kioskstats: {},
      from: "",
      to: "",
      cities:[],
      selectedcities:[],
      newspapers:[],
      selectednewspapers:[]
    };
  },
  name: "newsletterList",
  beforeMount() {},

  mounted() {
    var me = this;
  axios
        .get(`kiosk/cities`)
        .then((response) => {
          this.cities = response.data;
        });

         axios
        .get(`kiosk/newspapers`)
        .then((response) => {
          this.newspapers = response.data;
        });
  },
  methods: {
    toggleRow: function (code) {
      console.log(this.vrows);
      if (this.vrows[code]) {
        this.vrows[code] = false;
      } else {
        this.vrows[code] = true;
      }
     
    
    },
    viewNotes:function(notes){
      this.notes = notes;

        $("#noteModal").modal();
    },
    visibility: function (code) {
     
      return this.vrows[code];
    },
    edit: function (id) {
      this.$router.push({ name: "route-newsletter-edit", params: { id: id } });
      return false;
    },
    resetdata() {
      this.from = this.to ="";
      this.selectedcities = this.selectednewspapers = [];
    

      this.loaddata();
    },
  excel: function () {
      var me = this;
      var o = "ExportStatistiche.xlsx";
      
      axios
        .post(`kiosk/excel?from=${this.from}&to=${this.to}&c=${this.selectedcities.join("|")}&np=${this.selectednewspapers.join("|")}`, null, { responseType: "blob" })
        .then(function (result) {
          var blob = new Blob([result.data], {
            type: result.headers["content-type"],
          });

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // for IE
            window.navigator.msSaveOrOpenBlob(blob, o);
          } else {
            me.$refs.attachmentA.href = URL.createObjectURL(blob);
            me.$refs.attachmentA.download = o;
            me.$refs.attachmentA.click();
          }
        });
    },
    loaddata: function () {
      var me = this;
       this.years = [];
       this.kioskstats = [];
      axios
        .get(`kiosk/stats?from=${this.from}&to=${this.to}&c=${this.selectedcities.join("|")}&np=${this.selectednewspapers.join("|")}`)
        .then((response) => {
          for (var i in response.data) {
            var e = response.data[i];
            if(i == 0){
                for(var y=0; y<e.yrs.length;y++){
                  this.years.push(e.yrs[y].y);
                }

            }
           e.visible = false;
            for (var j in e.dates) {
            e.dates[j].visible = false;
            }
          }
          me.kioskstats = response.data;
        });
    },
  },
};
</script>
